import { NestedCheckGroup, NestedChecksView } from 'src/app/components/wizards/nested-checks.dialog.component'
import { ProgramLogisticsDisplayOptions } from 'globals/store/programs.data'



const pageChecks: NestedCheckGroup = {
  groupName: 'Page display options',
  checkboxes: [{
    label: 'Event name',
    id: ProgramLogisticsDisplayOptions.eventTitle
  },{
    label: 'Production view name',
    id: ProgramLogisticsDisplayOptions.viewName,
  },{
    label: 'Production view description',
    id: ProgramLogisticsDisplayOptions.viewDescription,
  },{
    label: 'Made with Joi logo',
    id: ProgramLogisticsDisplayOptions.madeWithJoi
  }]
}

const roomLocationChecks: NestedCheckGroup = {
  groupName: 'Room/location logistics display options',
  hideId: ProgramLogisticsDisplayOptions.roomTab,
  checkboxes: [{
      label: 'Date',
      id: ProgramLogisticsDisplayOptions.roomDate,
    },{
      label: 'Room/Location Assets',
      id: ProgramLogisticsDisplayOptions.assets,
    },{
      label: 'Venue details',
      id: ProgramLogisticsDisplayOptions.venueDetails,
    },{
      label: 'Exhibitors',
      id: ProgramLogisticsDisplayOptions.roomExhibitors,
    },{
      label: 'Tags',
      id: ProgramLogisticsDisplayOptions.roomTags,
    }]
}
const sessionChecks: NestedCheckGroup = {
  groupName: 'Session display options',
  hideId: ProgramLogisticsDisplayOptions.sessionsTab,
  checkboxes: [{
      label: 'Duration',
      id: ProgramLogisticsDisplayOptions.duration,
    },{
      label: 'Description',
      id: ProgramLogisticsDisplayOptions.sessionDescription,
    },{
      label: 'Staging notes',
      id: ProgramLogisticsDisplayOptions.stagingNotes,
    },{
      label: 'Staging items',
      id: ProgramLogisticsDisplayOptions.stagingItems,
    },{
      label: 'Staging files',
      id: ProgramLogisticsDisplayOptions.stagingFiles,
    },{
      label: 'Catering notes',
      id: ProgramLogisticsDisplayOptions.cateringNotes,
    },{
      label: 'Catering items',
      id: ProgramLogisticsDisplayOptions.cateringItems,
    },{
      label: 'Catering files',
      id: ProgramLogisticsDisplayOptions.cateringFiles,
    },{
      label: 'Staging requests',
      id: ProgramLogisticsDisplayOptions.stagingRequests,
    },{
      label: 'Public links',
      id: ProgramLogisticsDisplayOptions.publicLinks,
    },{
      label: 'Performers',
      id: ProgramLogisticsDisplayOptions.performers,
    },{
      label: 'Session Assets',
      id: ProgramLogisticsDisplayOptions.presentationAssets,
    },{
      label: 'Sponsors',
      id: ProgramLogisticsDisplayOptions.sponsors,
    },{
      label: 'Tags',
      id: ProgramLogisticsDisplayOptions.sessionTags,
    }]
}
const setupChecks: NestedCheckGroup = {
  groupName: 'Setup display options',
  hideId: ProgramLogisticsDisplayOptions.setupTab,
  checkboxes: [{
      label: 'Expected numbers',
      id: ProgramLogisticsDisplayOptions.expectedNumbers,
    },{
      label: 'Capacity',
      id: ProgramLogisticsDisplayOptions.capacity,
    },{
      label: 'Setup',
      id: ProgramLogisticsDisplayOptions.roomSetup,
    },{
      label: 'Setup notes',
      id: ProgramLogisticsDisplayOptions.setupNotes,
    },{
      label: 'Setup sessions',
      id: ProgramLogisticsDisplayOptions.setupSessions,
    },{
      label: 'Setup assets',
      id: ProgramLogisticsDisplayOptions.setupAssets,
    },{
      label: 'Setup access',
      id: ProgramLogisticsDisplayOptions.access,
    },{
      label: 'Setup cleared',
      id: ProgramLogisticsDisplayOptions.clear,
    }]
}

const generalInstructions = { instructions: { title: '', text: 'Choose what information displays in your Production view'} }

export const programLogsticsDisplayOptionsNestedFieldCheckGroups: NestedCheckGroup[] = [
  generalInstructions,
  pageChecks, 
  {
    groupName: 'Room/location logistics',
    tabId: ProgramLogisticsDisplayOptions.roomTab,
    noTabName: true,
    children: [roomLocationChecks]
  },{
    groupName: 'Setup',
    tabId: ProgramLogisticsDisplayOptions.setupTab,
    noTabName: true,
    children: [setupChecks]
  },{
    groupName: 'Sessions',
    tabId: ProgramLogisticsDisplayOptions.sessionsTab,
    noTabName: true,
    children: [sessionChecks]
  }
]


export type LogisticView = 'All' | 'Venues' | 'Setups' | 'Staging' | 'Assets' | 'Catering' | 'Exhibitions'
export const LogisticViewNames: { [v in LogisticView]: string } = { All: 'All', Setups: 'Set up', Staging: 'Staging', Venues: 'Venues', Assets: 'Session Assets', Catering: 'Catering', Exhibitions: 'Exhibitions' }


const setupFilters = [...setupChecks.checkboxes.map(({ id }) => id), ProgramLogisticsDisplayOptions.setupTab, ProgramLogisticsDisplayOptions.eventTitle, ProgramLogisticsDisplayOptions.viewName ]

const stagingFilters = [ ProgramLogisticsDisplayOptions.stagingNotes, ProgramLogisticsDisplayOptions.stagingItems, ProgramLogisticsDisplayOptions.stagingFiles, ProgramLogisticsDisplayOptions.stagingRequests, ProgramLogisticsDisplayOptions.sessionsTab ]

const displayOptions = Object.values(ProgramLogisticsDisplayOptions) as ProgramLogisticsDisplayOptions[]

export const LogisticViewExcludedIdMakers: { [v in LogisticView]: () => string[] } = {
  All: () => [],
  Exhibitions: () => displayOptions.filter(k => ![
    ProgramLogisticsDisplayOptions.roomTab,
    ProgramLogisticsDisplayOptions.roomDate,
    ProgramLogisticsDisplayOptions.venueDetails,
    ProgramLogisticsDisplayOptions.roomExhibitors
  ].includes(k)),
  Setups: () => displayOptions.filter(k => !setupFilters.includes(k)),
  Staging: () => displayOptions.filter(k => !stagingFilters.includes(k)),
  Venues: () => displayOptions.filter(k => ![
      ProgramLogisticsDisplayOptions.venueDetails,
      ProgramLogisticsDisplayOptions.roomTab,
      ProgramLogisticsDisplayOptions.eventTitle,
      ProgramLogisticsDisplayOptions.viewName,
      ProgramLogisticsDisplayOptions.roomDate,
      ProgramLogisticsDisplayOptions.setupTab,
      ProgramLogisticsDisplayOptions.expectedNumbers,
      ProgramLogisticsDisplayOptions.capacity,
      ProgramLogisticsDisplayOptions.roomSetup,
      ProgramLogisticsDisplayOptions.access,
      ProgramLogisticsDisplayOptions.clear
    ].includes(k)),
  Assets: () => displayOptions.filter(k => ![
      ProgramLogisticsDisplayOptions.presentationAssets,
      ProgramLogisticsDisplayOptions.sessionsTab, 
      ProgramLogisticsDisplayOptions.sessionDescription
    ].includes(k)),
  Catering: () => displayOptions.filter(k => ![
    ProgramLogisticsDisplayOptions.cateringFiles,
    ProgramLogisticsDisplayOptions.cateringNotes,
    ProgramLogisticsDisplayOptions.cateringItems,
    ProgramLogisticsDisplayOptions.sessionsTab
  ].includes(k)),
}


export const logisticsViewOptions: NestedChecksView<LogisticView>[] = [{ 
    id: 'All',
    title: LogisticViewNames.All, 
    deselectedIdMaker: LogisticViewExcludedIdMakers.All,
    ids: new Set(LogisticViewExcludedIdMakers.All())
  },{ 
    id: 'Venues',
    title: LogisticViewNames.Venues, 
    deselectedIdMaker: LogisticViewExcludedIdMakers.Venues,
    ids: new Set(LogisticViewExcludedIdMakers.Venues())
  },{ 
    id: 'Setups',
    title: LogisticViewNames.Setups, 
    deselectedIdMaker: LogisticViewExcludedIdMakers.Setups,
    ids: new Set(LogisticViewExcludedIdMakers.Setups())
  },{ 
    id: 'Staging',
    title: LogisticViewNames.Staging, 
    deselectedIdMaker: LogisticViewExcludedIdMakers.Staging,
    ids: new Set(LogisticViewExcludedIdMakers.Staging())
  },{ 
    id: 'Assets',
    title: LogisticViewNames.Assets, 
    deselectedIdMaker: LogisticViewExcludedIdMakers.Assets,
    ids: new Set(LogisticViewExcludedIdMakers.Assets())
  },{ 
    id: 'Catering',
    title: LogisticViewNames.Catering, 
    deselectedIdMaker: LogisticViewExcludedIdMakers.Catering,
    ids: new Set(LogisticViewExcludedIdMakers.Catering())
  }
]